import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './OrderSuccess.css';

const OrderSuccess = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const orderId = state?.orderId || '—';
  const phone = state?.phone || '';

  return (
    <div className="os-page">
      <div className="os-card">
        <div className="os-icon">✅</div>
        <h1 className="os-title">Order Placed!</h1>
        <p className="os-sub">Thank you for your order. We'll confirm it shortly.</p>

        <div className="os-detail-box">
          <div className="os-detail-row">
            <span>Order ID</span>
            <strong>#{String(orderId).padStart(5, '0')}</strong>
          </div>
          <div className="os-detail-row">
            <span>Payment</span>
            <strong>Cash on Delivery</strong>
          </div>
          {phone && (
            <div className="os-detail-row">
              <span>Contact</span>
              <strong>{phone}</strong>
            </div>
          )}
        </div>

        <p className="os-note">
          You can track and manage your orders from the <strong>My Orders</strong> section.
        </p>

        <div className="os-actions">
          <button className="os-btn-orders" onClick={() => navigate('/orders')}>
            View My Orders
          </button>
          <button className="os-btn-home" onClick={() => navigate('/')}>
            Continue Shopping
          </button>
        </div>
      </div>
    </div>
  );
};

export default OrderSuccess;
